<template>
  <div id="mirri">
    <div class="large-12 medium-12 small-12 columns" v-if="states.mPkgs.length > 0">
      <div v-for="sPkg in states.mPkgs" :key="sPkg.buckets.name">
        <div class="row">
            <div class="large-12 medium-12 small-12 columns">
                <div class="left cre-detail"><strong v-text="sPkg.pkgTitle" /></div>
            </div>
        </div>
        <div class="progress-bar" v-if="!sPkg.isInfinite">
            <div class="vonkajsi">
                <div class="vnutorny shadow" v-bind:style="{ width: sPkg.pgPercentage + '%' }"> <span class="inner-text text-left">Prenesené z voľných</span> </div>
                <div class="vnutorny-right" v-bind:style="{ width: (100 - sPkg.pgPercentage) + '%' }"> <span class="inner-text text-right-in">{{ orchDataConsumption(sPkg.bucketSize, sPkg.buckets.value) }}</span>
            </div>
        </div> <span class="inner-text text-left-out">Prenesené z voľných</span> <span class="inner-text text-right">{{ orchDataConsumption(sPkg.bucketSize, sPkg.buckets.value) }}</span> </div>
        <div class="progress-bar" style="position:relative;"  v-if="sPkg.isInfinite"><span class="inner-text text-right-in">neobmedzene</span>
            <div class="vnutorny" style="width: 51%">
                <div class="opacity-grad"><span class="inner-text text-left-inf">Internet</span></div>
            </div>
        </div>      
        <div class="row">
        <div class="large-12 medium-12 small-12 columns">
          <div class="mixi_validity">
            <span class="inline">Platí do</span><span class="right">{{ sPkg.validity }}</span>
          </div>
        </div>
        </div>
      </div>
    <hr />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { orchDataConsumption } from '@/services'
export default {
  name: 'mirri',
  props: ['productdetail', 'tplData'],
  data () {
    return {
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: { mPkgs: [] },
      msisdn: '',
      orchDataConsumption,
      namesMap: {}
    }
  },
  created: function() {
    var that = this;
    let mPkgs = [];

    if (_.isObject(this.tplData.package.name)) {
      _.assign(this.namesMap, this.tplData.package.name)
    }
    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageTotal' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageTotal' })[0]
      if (thisPkg.buckets.endDate) {
        if ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)) && !_.isEmpty(String(thisPkg.buckets.value))) {
          mPkgs.push(thisPkg)
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageMonthly' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageMonthly' })[0]
      if (thisPkg.buckets.endDate) {
        if ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)) && !_.isEmpty(String(thisPkg.buckets.value))) {
          mPkgs.push(thisPkg)
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageSSD' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageSSD' })[0]
      if (thisPkg.buckets.endDate) {
        if ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)) && !_.isEmpty(String(thisPkg.buckets.value))) {
          mPkgs.push(thisPkg)
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageADDON' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'MIRRIDataPackageADDON' })[0]
      if (thisPkg.buckets.endDate) {
        if ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)) && !_.isEmpty(String(thisPkg.buckets.value))) {
          mPkgs.push(thisPkg)
        }
      }
    }
    const priorityList = ['MIRRI_ADDON', 'MIRRI_INITIAL_MONTHLY', 'MIRRI_INITIAL_TOTAL', 'MIRRI_INITIAL_SSD'];
    mPkgs = _.orderBy(mPkgs, (itm) => { const priorityIndex = priorityList.indexOf(itm.buckets.name); return priorityIndex !== -1 ? priorityIndex : priorityList.length });
    _.forEach(mPkgs, function(pkg, kp) {
      pkg.isInfinite = (pkg.buckets?.name || '').slice(-4) === '_SSD';
      pkg.pgPercentage = 100 - (((pkg.buckets.value || pkg.bucketSize) / pkg.bucketSize) * 100);
      if (pkg.pgPercentage < 0) { pkg.pgPercentage = 0; }
      pkg.validity = moment(pkg.buckets.endDate).format('D.M.YYYY H:mm');
      pkg.pkgTitle = that.namesMap[pkg.buckets.name] || pkg.buckets.name; 
    })
    this.states.mPkgs = mPkgs;
  }
}
</script>
<style scoped>
  .cre-detail {
    padding-left: 0;
    padding-bottom: 0.3rem;
    margin-top: 0.4rem;
  }
</style>
